module.exports = __webpack_public_path__ + "assets/img/more_vert_24px.282c961b.svg";